import {ChangeDetectionStrategy, Component, input} from '@angular/core';

@Component({
  selector: 'oph-metric-bar-chart',
  standalone: true,
  templateUrl: './oph-metric-bar-chart.component.html',
  styleUrl: './oph-metric-bar-chart.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OphMetricBarChartComponent {
  readonly dailyScores = input.required<number[]>();
  readonly color = input.required<string>();
  readonly height = input(61);
  readonly barBorderRadius = input(8);
}
